/* Dansk katalog for locale-payroll-payments-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'err.pensionCorrection.inactive': 'Ingen aktiv OTP-betaling at rette.',
  'err.pensionCorrection.legacy': 'Denne historiske OTP-betaling skal rettes efter en regnskabsmæssig gennemgang.',
  'err.pensionCorrection.stale': 'OTP-betalingen er ændret. Genindlæs siden før rettelse.',
  'err.pensionCorrection.reason': 'Angiv årsagen til rettelsen.',
  'err.pensionCorrection.reported': 'A-meldingen skal gennemgås, før OTP i indberettet løn kan rettes.',
  'err.pensionCorrection.settled': 'Annuller terminsbetalingen af arbejdsgiverafgift, før OTP rettes.',
  'err.pensionCorrection.missing': 'Kan ikke finde bogføringen af OTP-betalingen.',
  'pay.viewPensionPosting': 'Se postering',
  'pay.pensionDetails': 'Se betaling',
  'pay.correctPensionPayment': 'Ret OTP-betaling',
  'pay.annulPensionPayment': 'Annuller OTP-betaling',
  'pay.pensionCorrectionSaved': 'OTP-betalingen er rettet.',
  'pay.correctionReason': 'Årsag til rettelse',
  'pay.pensionCorrectionExplanation': 'Den oprindelige OTP-betaling modposteres i den oprindelige, åbne periode. Ved rettelse registreres en ny betaling. Lønkørslen og lønudbetalingen bevares. Det ændrer bogføringen, ikke en gennemført bankoverførsel.',
  'trv.approveExpense': 'Godkend udlæg',
  'pay.taxOnNonCashBenefits': 'Skattetræk på naturalieydelser',
  'pay.netReconciliation': 'Afvigelse mellem lønlinjerne og gemt nettoløn',
  'pay.netAdjustmentExplanation': 'Trækkes fra kontant udbetaling; skatten er inkluderet ovenfor.',
  'pay.viewPayslip': 'Se lønseddel',
  'pay.resendPayslip': 'Send igen',
  'pay.missingPensionBankAccountReminder': 'Du har ikke tilføjet en bankkonto. Husk at tilføje den konto, pensionen er betalt fra. Du kan alligevel registrere betalingen.',
  'pay.missingBankAccountReminder': 'Du har ikke tilføjet en bankkonto. Husk at tilføje den konto, lønnen er betalt fra. Du kan alligevel registrere udbetalingen.',
});
